import { FilterOptionOption } from 'react-select'

/** Use for dropdowns where only the visible label should be searched (e.g. dates/periods), so IDs/values never cause spurious matches. */
export const labelOnlySubstringFilter = (
	option: FilterOptionOption<{ label: string }>,
	searchText: string
): boolean => {
	return option.label.toLowerCase().includes(searchText.toLowerCase())
}

/** Use for dropdowns where the id/value and region should also be searchable alongside the label (e.g. country/company pickers). */
export const multiFieldSubstringFilter = (
	option: FilterOptionOption<{ value: string; region: string; label: string }>,
	searchText: string
): boolean => {
	return (
		option.data.value.toLowerCase().includes(searchText.toLowerCase()) ||
		option.data.region.toLowerCase().includes(searchText.toLowerCase()) ||
		option.data.label.toLowerCase().includes(searchText.toLowerCase())
	)
}
